<template lang="pug">
  .form-popup
    .form-popup__wrapper
      .form-popup__title
        .h2
          .h2__wrapper.h2__wrapper-center(v-html="settings.setting.title")
      .form-popup__fields
        .form-popup__field
          .input-text
            input.input-text__input.input-text__input-gray(
              :placeholder= "fields.field_1.placeholder"
              type= "text"
              v-model="name"
            )
        .form-popup__field
          .input-text
            input.input-text__input.input-text__input-gray(
              :placeholder= "fields.field_2.placeholder"
              type= "tel"
              v-model="phone"
              @blur="$v.phone.$touch()"
              v-mask="'+7 (###) ###-##-##'"
              :class="{'input-text__input-error': ($v.phone.$error) && (phone.length > 0)}"
            )
      .form-popup__consent
        .consent
          .consent__wrapper
            input.consent__input(
              type="checkbox"
              id="form-contact_consent2"
              checked="checked"
              value="consent"
              v-model="consent"
            )
            label.consent__label.consent__label-small(for="form-contact_consent2" v-html="fields.field_consent.placeholder")
      .form-popup__button
        .form-popup__button-wrapper
          .button(
            @click="getSend()"
            :class="{'button-disable': $v.$invalid}"
          )
            .button__wrapper(
              v-html="settings.setting.buttonText"
              :class="{'settings.button.classButtonText': settings.button.classButtonText !== '', 'button__text-disable': $v.$invalid}"
            )
</template>

<script>
import {maxLength, minLength, required} from 'vuelidate/lib/validators'
import {TheMask} from 'vue-the-mask'

export default {
  name: 'AppFormPopupPhone',

  components: {
    TheMask
  },

  data () {
    return {
      settings: {},
      fields: {},
      name: '',
      phone: '',
      consent: ['consent']
    }
  },

  methods: {
    getSend () {
      if (!this.$v.$invalid) {
        this.$store.dispatch('Send', {
          setting: {
            title: 'Заявка с формы',
            subject: 'Заявка с формы "Заявка на партнерство"'
          },

          fields: [
            {
              title: 'Имя',
              value: this.name
            },

            {
              title: 'Телефон',
              value: this.phone
            },

            {
              title: 'Отправлено со страницы',
              value: this.settings.setting.page.name
            },

            {
              title: 'id страницы',
              value: this.settings.setting.page.id
            }
          ],
          files: ''
        })

        // закрыаем основное окно с формой
        $.fancybox.close()

        // открываем окно с благодрностью
        $('.button-popup-success').click()
        setTimeout(() => {
          $.fancybox.close()
        }, 3000
        )

        this.name = ''
        this.phone = ''
      }
    }
  },

  validations: {
    phone: {
      required,
      minLength: minLength(18),
      maxLength: maxLength(18)
    },

    consent: {
      required
    }
  },

  created () {
    this.settings = window.RbcApp.arFormPopupPhone
    this.fields = this.settings.setting.fields
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/AppFormPopupPhone.vue